// src/components/FriendsSearchScreen.js
import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase'; // Adjust path
import './FriendsSearchScreen.css';

function FriendsSearchScreen() {
  // Search states
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedLetter, setSelectedLetter] = useState('');
  const [friendsList, setFriendsList] = useState([]);

  // Selected friend details
  const [selectedFriend, setSelectedFriend] = useState(null);
  const [friendPosts, setFriendPosts] = useState([]);

  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  useEffect(() => {
    fetchFriends();
    // eslint-disable-next-line
  }, [searchTerm, selectedLetter]);

  // 1. Fetch users from Firestore (assuming isJournalist = false or all users)
  async function fetchFriends() {
    try {
      // If you want to exclude journalists, do: where('isJournalist','==', false)
      // or if you just want ALL users, remove that filter
      let q = query(collection(db, 'users'));

      if (searchTerm) {
        // "Starts with" approach
        q = query(
          collection(db, 'users'),
          where('username', '>=', searchTerm),
          where('username', '<=', searchTerm + '\uf8ff')
        );
      } else if (selectedLetter) {
        q = query(
          collection(db, 'users'),
          where('username', '>=', selectedLetter),
          where('username', '<=', selectedLetter + '\uf8ff')
        );
      }

      const querySnapshot = await getDocs(q);
      const results = [];
      querySnapshot.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() });
      });
      setFriendsList(results);
    } catch (error) {
      console.error('Error fetching friends:', error);
    }
  }

  // 2. Select a friend to see their posts
  async function handleSelectFriend(friend) {
    setSelectedFriend(friend);
    try {
      // Fetch friend posts from 'posts' collection
      const q = query(collection(db, 'posts'), where('userId', '==', friend.id));
      const querySnapshot = await getDocs(q);
      const posts = [];
      querySnapshot.forEach((doc) => {
        posts.push({ id: doc.id, ...doc.data() });
      });
      setFriendPosts(posts);
    } catch (error) {
      console.error('Error fetching friend posts:', error);
    }
  }

  // 3. Like / Share / Comment placeholders
  function handleLike(postId) {
    alert(`Liked post ${postId}`);
  }
  function handleShare(postId) {
    alert(`Shared post ${postId}`);
  }
  function handleComment(postId) {
    alert(`Comment on post ${postId}`);
  }

  return (
    <div className="friends-container">
      {/* Header */}
      <header className="friends-header">
        <h2>Friends Search</h2>
      </header>

      {/* Search Bar */}
      <div className="friends-search-bar">
        <input
          type="text"
          placeholder="Search friends..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setSelectedLetter('');
          }}
        />
      </div>

      {/* Alphabetical List */}
      <div className="alphabet-list">
        {letters.map((letter) => (
          <button
            key={letter}
            className={`alpha-btn ${
              selectedLetter === letter ? 'active' : ''
            }`}
            onClick={() => {
              setSelectedLetter(letter);
              setSearchTerm('');
            }}
          >
            {letter}
          </button>
        ))}
      </div>

      {/* Friends Grid */}
      <div className="friends-grid">
        {friendsList.map((f) => (
          <div
            key={f.id}
            className="friend-card"
            onClick={() => handleSelectFriend(f)}
          >
            <img
              src={f.profileImage || '/user-placeholder.png'}
              alt="Friend"
              className="friend-avatar"
            />
            <p className="friend-username">{f.username}</p>
          </div>
        ))}
      </div>

      {/* Selected Friend Panel */}
      {selectedFriend && (
        <div className="selected-friend-panel">
          <h3>Selection Appears Here</h3>
          <div className="selected-friend-info">
            <img
              src={selectedFriend.profileImage || '/user-placeholder.png'}
              alt="Selected Friend"
              className="friend-avatar"
            />
            <div>
              <p className="friend-username">{selectedFriend.username}</p>
              {/* Additional details, like rating or friend status */}
            </div>
          </div>

          {/* Friend's Posts */}
          <div className="friend-posts">
            {friendPosts.length === 0 ? (
              <p>No posts found for this friend.</p>
            ) : (
              friendPosts.map((post) => (
                <div key={post.id} className="post-card">
                  <h4>{post.title || 'Video Title'}</h4>
                  <p>{post.description || 'No description'}</p>
                  <p>Date: {post.date || 'N/A'}</p>
                  {/* Like / Share / Comment */}
                  <div className="post-actions">
                    <button onClick={() => handleLike(post.id)}>Like</button>
                    <button onClick={() => handleShare(post.id)}>Share</button>
                    <button onClick={() => handleComment(post.id)}>
                      Comment
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default FriendsSearchScreen;
